export const MOSCOW_ID = 1;
export const MOSCOW_REGION_ID = 4593;
export const MOSCOW_AND_REGION = [MOSCOW_ID, MOSCOW_REGION_ID];
export const MOSCOW_AND_REGION_ID = -1;

export const SPB_ID = 2;
export const SPB_REGION_ID = 4588;
export const SPB_AND_REGION = [SPB_ID, SPB_REGION_ID];
export const SPB_AND_REGION_ID = -2;

export const MOSCOW_WITH_SPB_AND_REGIONS = [...MOSCOW_AND_REGION, ...SPB_AND_REGION];
